
import { countries } from '@/config/i18n/countries'
import { defineComponent, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'LanguageMenu',
  components: {},
  setup () {
    const i18n = useI18n()

    i18n.locale.value = localStorage.getItem('lang')
      ? (localStorage.getItem('lang') as string)
      : 'fr-FR'

    onMounted(() => {
      const queryParams = new URLSearchParams(window.location.search)
      let langParam = queryParams.get('lang')
      if (langParam !== null) {
        // Si la langue n'existe pas dans countries, alors mettre la langue par défaut
        if (!Object.keys(countries).includes(langParam)) {
          langParam = 'fr-FR'
        }
        setLang(langParam)
        currentLanguage(langParam)
      }
    })

    const setLang = (lang: string) => {
      localStorage.setItem('lang', lang)
      i18n.locale.value = lang
    }

    const currentLanguage = (lang: string) => {
      return i18n.locale.value === lang
    }

    const currentLanguageLocale = computed(() => {
      return countries[i18n.locale.value]
    })

    return {
      setLang,
      currentLanguage,
      currentLanguageLocale,
      countries
    }
  }
})
